import React, {useEffect} from 'react';

import {createHashHistory} from "history";
import {ErrorBoundary} from "react-error-boundary";
import {HashRouter as Router, Route, Routes} from 'react-router'

import Main from './Components/Main'
import ErrorPage from "./Components/Util/Error/ErrorPage";
import ScrollToTop from "./Components/Util/ScrollToTop";
import {ConfigProvider} from "./ConfigProvider";
import Analytics from './Google/Analytics';

import "./App.css";

const originalErr = window.console.error
window.console.error = (...args) => {
    const ignored = [
        'uses the legacy childContextTypes API which is no longer supported',
        'uses the legacy contextTypes API which is no longer supported',
        'Support for defaultProps will be removed'
    ]
    if (args?.length > 0 && ignored.some(ignore => args[0].includes(ignore))) return
    originalErr(...args)
}

const history = createHashHistory();

const analytics = Analytics.getInstance();

history.listen(location => {
    let path = location.pathname ? location.pathname : location.location ? location.location.pathname : 'unknown_path';
    analytics.set({page: path});
});

const ExternalRedirect = ({url}) => {
    useEffect(() => {
        window.location.replace(url)
    }, [url])
}

const App = () => {
    return (
        <ErrorBoundary fallback={<ErrorPage description={'Looks like a rendering error occurred. Please try refreshing the page or returning to Portal.'}/>}>
            <ConfigProvider>
                <Router>
                    <ScrollToTop/>
                    <Routes>
                        <Route path="/403/redirect" element={<ExternalRedirect url={`${window.location.protocol}//${window.location.host}/403`}/>}/>
                        <Route path="/login/redirect" element={<ExternalRedirect url={`${window.location.protocol}//${window.location.host}/login`}/>}/>
                        <Route path="/logout/redirect" element={<ExternalRedirect url={`${window.location.protocol}//${window.location.host}/logout`}/>}/>
                        <Route name="index" path="*" element={<Main/>}/>
                    </Routes>
                </Router>
            </ConfigProvider>
        </ErrorBoundary>
    )
};

export default App;